import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './styles.scss'
import { reduxForm } from 'redux-form'

class NotFoundComponent extends Component {
  componentDidMount() {
    localStorage.clear()
  }

  render() {
    return (
      <div>
        <main id="notfound-page">
          <div className="wrapper">
            <header className="header display-flex d-blck d-md-none d-md-none">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 align-middle d-flex  align-items-center justify-content-center">
                    <Link className="close" to="/login">
                      <img alt="" src="img/close-icon.png" />
                    </Link>
                  </div>
                </div>
              </div>
            </header>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 login-box-left">
                  <div className="login-box-left-inner">
                    <h1 className="page-title d-blck d-md-none">Notice!</h1>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p className="d-block d-md-none"></p>
                </div>
                <div className="col-md-12 text-center">
                  <Link className="link" to="/login">
                    This operation is not allowed. Please re-login! Got It
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}

export default reduxForm({
  form: 'NotFound', // a unique identifier for this form
  destroyOnUnmount: true
})(NotFoundComponent)



// WEBPACK FOOTER //
// ./src/views/NotFound/component.js